import { render } from "./InviteShare.vue?vue&type=template&id=dfcdc814&scoped=true"
import script from "./InviteShare.vue?vue&type=script&lang=js"
export * from "./InviteShare.vue?vue&type=script&lang=js"

import "./InviteShare.vue?vue&type=style&index=0&id=dfcdc814&scoped=true&lang=css"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfcdc814"]])

export default __exports__